import { Dialog } from "./index";
import { QrReader } from "react-qr-reader";
import { useRef, useState } from "react";
import { Button } from "primereact/button";
export const Leerqr = ({ openqr, setopenqr, qrset }) => {
	// console.log(product);
	// const [data, setData] = useState("No result");
	// const [capturedData, setCapturedData] = useState(null);
	const qrReaderRef = useRef(null);
	const handleResult = (result, error) => {
		if (!!result) {
			console.log(result?.text);
			qrset(result?.text);
		}
		// if (!!error) {
		// 	console.info(error);
		// }
	};

	const deleteProductDialogFooter = (
		<>
			<Button
				label='Cancelar'
				icon='pi pi-times'
				className='p-button-raised p-button-info p-button-text'
				onClick={() => {
					setopenqr(false);
				}}
			/>
		</>
	);

	return (
		<>
			<Dialog
				visible={openqr}
				style={{ width: "450px" }}
				header='Leer QR'
				modal
				footer={deleteProductDialogFooter}>
				<QrReader
					ref={qrReaderRef}
					onResult={handleResult}
					constraints={{ facingMode: "environment" }}
					style={{ width: "50%" }}
				/>
				{/* <button onClick={handleCapture}>Capturar Código QR</button> */}
				{/* {capturedData && <p>Código QR capturado: {result?.text}</p>} */}
			</Dialog>
		</>
	);
};
